export default "__VITE_ASSET__DzH38eOB__"